// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://a.z0n.net/api'
    : 'http://localhost:8000/api');

export const API_ENDPOINTS = {
  JOBS: `${API_BASE_URL}/public/jobs`,
  APPLY: `${API_BASE_URL}/public/apply`,
};

export default API_BASE_URL;
